import React from "react"
import { useDispatch } from "react-redux"

import { Modal } from "components/Modal/Modal"
import { logout } from "containers/Login/services/actions"
import { cdn } from "core/cdn"
import { useLanguage } from "locales"

const TeleexpertiseEnd: React.FC = () => {
  const dispatch = useDispatch()
  const { languages } = useLanguage()

  return (
    <Modal
      visible
      title={languages.dermatoPharmaTitle}
      acceptText={languages.finishAndDisconnect}
      acceptButtonProps={{ type: "primary" }}
      onAccept={() => dispatch(logout())}
    >
      <div>
        <img
          src={cdn("/images/tlc_terminee_illustration_blue.svg")}
          alt=""
          style={{ height: 300, display: "block", margin: "0 auto 50px" }}
        />
        <p
          style={{
            fontSize: 32,
            fontWeight: 500,
            color: "#211452",
            textAlign: "center",
            margin: "0 auto",
            maxWidth: "90%",
          }}
          dangerouslySetInnerHTML={{
            __html: languages.dermatoPharmaDescription,
          }}
        />
      </div>
    </Modal>
  )
}

export default TeleexpertiseEnd
